export default __webpack_public_path__ + "static/media/shape.47b3bd33.svg";